import Config from '../../config';
import authEndpoints from './authEndpoints';
import apiClient from '../apiClient';

export const CreateNewPassword = async ({
  email,
  password,
  code,
}: {
  email: string;
  password: string;
  code: string;
}) => {
  const { API_URL } = Config;
  const response = await apiClient.post(
    `${API_URL}${authEndpoints.CreateNewPasswordEndpoint}`,
    {
      email,
      password,
      code,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response;
};
